module.exports = __webpack_public_path__ + "static/media/hat.a3e35e37.png";